export enum ReportSource {
    BulkExport,
    CustomSearch,
    Report,
    AnimalCheck,
}
